const pickerOptions = [
    { id: 1, name: 'General Liability' },
    { id: 3, name: 'Commercial Auto' },
    { id: 9, name: "Workers' Compensation" },
    { id: 8, name: 'Property Insurance' },
    { id: 7, name: 'Professional Liability/E&O' },
    { id: 10, name: 'Business Owners Policy' },
    { id: 20, name: 'Cyber Liability' },
    { id: 39, name: 'Cargo' },
    { id: 37, name: 'Umbrella/Excess Liability' },
    { id: 35, name: 'Group Health' },
    { id: 38, name: 'Inland Marine' },
    { id: 16, name: 'Other' },
];

export default pickerOptions;
